export default "__VITE_ASSET__B7sW0Rz$__"